import { gql } from '@apollo/client';

export default gql`
  query getPortalCollecs($branch: String) {
    getPortalCollecs(branch: $branch) {
      ok
      error
      data {
        _id
        name
        nameAr
        icon
        image
        headimage
        order
        slug
        list
        items {
          _id
          branch
          autoNo
          slug
          itemType
          expenseType
          barcode
          disabled
          additionId
          publish

          name
          nameAr
          desc
          descAr

          sectionId
          sectionName
          sectionNameAr
          sectionSlug
          sectionOrder

          categoryId
          categoryName
          categoryNameAr
          categorySlug
          categoryOrder

          collecs

          brandId
          brandName
          brandNameAr

          qty
          cost
          price
          unit
          size
          weight
          color
          photo
          photoAr
          photos
          salesCurve

          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
  }
`;
